import { createComponent } from '@carvana/merch-components';
import { legacyBreakpoints } from '@carvana/merch-tailwind/breakpoints';
import styled from 'styled-components';

export const Wrapper = createComponent('div', {
  className: 'flex flex-col p-16 m:p-24'
});

export const Text = createComponent('p', {
  className: 'mb-16 text-center text-blue-7 tl-body-s m:mb-24'
});

export const VehicleGrid = styled.div.attrs({
  className: 'gap-16 grid mx-auto'
})`
  @media (min-width: ${legacyBreakpoints.m}px) {
    grid-template: auto / repeat(2, 1fr);
  }
`;
